<template>
  <ion-page>
    <ion-content fullscreen />
    <ion-footer class="ion-padding footer-onboarding">
      <h1 v-if="config.appname">
        {{ config.appname }}
      </h1>
      <p class="ion-margin-bottom">
        {{ $t('login.title') }}
      </p>
      <ion-button
        v-if="nativeIos"
        color="light"
        expand="block"
        @click="loginApple"
      >
        <ion-icon
          slot="start"
          color="medium"
          :icon="logoApple"
        />
        {{ $t('login.apple') }}
      </ion-button>
      <!-- <ion-button
        color="light"
        expand="block"
      >
        <ion-icon
          slot="start"
          color="google"
          :icon="logoGoogle"
        />
        Inloggen met Google
      </ion-button> -->
      <ion-button
        v-if="config.show_facebook_login"
        color="light"
        expand="block"
        @click="loginFacebook"
      >
        <ion-icon
          slot="start"
          color="medium"
          :icon="logoFacebook"
        />
        {{ $t('login.facebook') }}
      </ion-button>
      <ion-button
        color="light"
        expand="block"
        @click="loginEmail"
      >
        <ion-icon
          slot="start"
          color="primary"
          :icon="mail"
        />
        {{ $t('login.email') }}
      </ion-button>
      <ion-button
        v-if="nativeIos"
        fill="clear"
        expand="block"
        color="medium"
        class="text-sm underline ion-no-margin"
        @click="$router.push({ name: 'start' })"
      >
        {{ $t('login.continue') }}
      </ion-button>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import { IonFooter, loadingController, modalController } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import {
  logoApple,
  logoGoogle,
  logoFacebook,
  mail,
} from 'ionicons/icons';
import { SignInWithApple } from '@capacitor-community/apple-sign-in';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import OnboardingName from '@/components/OnboardingName.vue';
import LoginEmail from '@/components/LoginEmail.vue';
import AuthService from '@/services/Auth';
import UserService from '@/services/User';
import store from '@/store';

export default defineComponent({
  components: {
    IonFooter,
  },
  setup() {
    return {
      logoApple,
      logoGoogle,
      logoFacebook,
      mail,
    };
  },
  computed: {
    nativeIos() {
      return Capacitor.getPlatform() === 'ios';
    },
    config: () => store.config,
  },
  methods: {
    /**
     * Handle login.
     *
     * @param {Function} callback
     */
    async handleLogin(callback) {
      const loading = await loadingController.create({
        message: this.$t('general.loading'),
      });
      await loading.present();
      const user = await callback();
      await loading.dismiss();

      await modalController.dismiss();

      // If logged-in and boarded, go to start
      if (user.onboarding_completed) {
        this.$router.push({ name: 'start' });
        return;
      }

      const modal = await modalController.create({
        component: OnboardingName,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await modal.present();
    },
    /**
     * Log in with apple.
     */
    async loginApple() {
      const host = await AuthService.getHost();
      const response = await SignInWithApple.authorize({
        clientId: this.config.appid,
        redirectURI: `https://${host}/login`,
        scopes: 'email name',
      });

      if (response?.response?.identityToken) {
        await this.handleLogin(() => UserService.loginWithApple({
          first_name: response.response.givenName,
          last_name: response.response.familyName,
          email: response.response.email,
          apple_token: response.response.identityToken,
        }));
      }
    },
    /**
     * Log in with facebook.
     */
    async loginFacebook() {
      const result = await FacebookLogin.login({ permissions: ['public_profile', 'email'] });
      if (result.accessToken) {
        await this.handleLogin(() => UserService.loginWithFacebook(result.accessToken.token));
      }
    },
    /**
     * Log in with e-mail.
     */
    async loginEmail() {
      await modalController.dismiss();

      const modal = await modalController.create({
        component: LoginEmail,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await modal.present();
    },
  },
});
</script>

<style scoped>
ion-content {
  --background: none;
}

ion-router-link {
  display: block;
  text-align: center;
  text-decoration: underline;
}
</style>
